import { createFileRoute } from '@tanstack/react-router'
import { ReservationsPage } from '@/components/reservations/ReservationsPage'

// Table reservations + walk-in waitlist (F-RSV-N1). Renders a "switched off"
// note unless an admin has turned reservations on in Settings.
export const Route = createFileRoute('/admin/reservations')({
  component: ReservationsPage,
})
